<template>
  <div>
      <AdminNavBar />

      <Panel header="Dashboard" class="p-mt-2">
        
        Admin dashboard
        
      </Panel>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AdminNavBar from '../components/AdminNavBar.vue'

export default {
  name: 'AdminDashboard',
  components: {
    AdminNavBar,
  },
  data () {
    return {
    }
  },
  created: function () {
    //this.GetDomain(this.$route.params.domain_id)
  },
  computed: {
    //...mapGetters({ Users: 'StateUsers' }),
  },
  created: function () {
  },
  methods: {
    //...mapActions(['CreateDomain', 'GetDomains']),
    //async submit () {
    //  await this.CreateDomain(this.form)
    //},
    //async selectDomain(id) {
    //  console.log("selectDomain", id)
    //  this.$router.push('/domains/' + id + '/mail/accounts')
    //  
    //}
  }
}
</script>

<style scoped>

</style>
